// src/api/match.js
import axios from 'axios'  // 替换原有的 request 导入

// 匹配相关接口
const matchApi = {
  // 保存用户偏好
  savePreference(data) {
    return axios.post('/match-service/api/match/preference', data)  // 改为 axios
  },
  // 获取用户偏好
  getPreference(userId) {
    return axios.get('/match-service/api/match/preference', { params: { userId } })  // 改为 axios
  },
  // 获取推荐用户
  getRecommendUsers(userId, pageNum = 1, pageSize = 10) {
    return axios.get('/match-service/api/match/recommend', {  // 改为 axios
      params: { userId, pageNum, pageSize } 
    })
  },
  // 喜欢用户
  likeUser(data) {
    return axios.post('/match-service/api/match/like', data)  // 改为 axios
  },
  // 拒绝用户
  rejectUser(data) {
    return axios.post('/match-service/api/match/reject', data)  // 改为 axios
  },
  // 获取匹配成功用户
  getMatchedUsers(userId, pageNum = 1, pageSize = 10) {
    return axios.get('/match-service/api/match/matched', {  // 改为 axios
      params: { userId, pageNum, pageSize } 
    })
  },
  // 记录浏览
  recordView(viewerId, viewedUserId) {
    return axios.post('/match-service/api/match/view', { viewerId, viewedUserId })  // 改为 axios
  },
  // 获取谁看过我
  getViewedMe(userId, pageNum = 1, pageSize = 10) {
    return axios.get('/match-service/api/match/viewed-me', {  // 改为 axios
      params: { userId, pageNum, pageSize } 
    })
  }
  ,  
    // 获取谁看过我
  getLikedMe(userId, pageNum = 1, pageSize = 10) {
    return axios.get('/match-service/api/match/like-me', {  // 改为 axios
      params: { userId, pageNum, pageSize } 
    })
  }
  ,  
  // 更新用户位置
updateLocation(params) {
  return axios({
    url: '/match-service/api/match/update-location',
    method: 'post',
    params: params  // 注意这里用params（查询参数），而非data（请求体）
  });
},
  // updateQuantity(params) {
  //   return axios({
  //     url: '/product-service/api/cart/update/quantity',
  //     method: 'post',
  //     data: params
  //   })
  // },
  // 获取附近的人
  getNearbyPeople(userId, radius = 3000, count = 20) {
    return axios.get('/match-service/api/match/nearby-people', {
      params: { userId, radius, count }
    })
  }

  
}
export default matchApi